import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';

import MyTIContent from './Content';
import type { MyTIProps } from './interfaces';

const queryClient = new QueryClient();

const MyTI = ({
  env,
  forumPosts,
  initialCurrentUser,
  isGdprRequired,
  isWebview,
  newsletterNames,
}: MyTIProps) => {
  return (
    <AppContextProvider
      env={env}
      initialCurrentUser={initialCurrentUser}
      isGdprRequired={isGdprRequired}
      isWebview={isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <MyTIContent
          forumPosts={forumPosts}
          initialCurrentUser={initialCurrentUser}
          newsletterNames={newsletterNames}
        />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default MyTI;
